import React from 'react'
import { useSettings } from '../context/SettingsContext';
import { Link } from 'react-router-dom';

const Social = () => {

    const { settings } = useSettings();

    const isLoading = settings === null || !settings.social || !settings.social.icons || !settings.social.links;

    if (isLoading) {
        return (
            <ul className="skeleton-list">
                {[...Array(4)].map((_, i) => (
                    <li key={i} className="skeleton-icon" />
                ))}
            </ul>
        );
    }

    const { icons, links } = settings.social;

    return (
        <>
            <div className='footer-social'>
                {icons.map((icon, index) => (
                    <Link key={index} to={links[index] || '#'}>
                        <i className={`fa-brands ${icon}`} />
                    </Link>
                ))}
            </div>
        </>
    )
}

export default Social